import React from 'react';
import { X } from 'lucide-react';
import type { ApplicantFilter } from '../../types/applicant';

interface ApplicantFilterPanelProps {
  isOpen: boolean;
  onClose: () => void;
  filters: ApplicantFilter;
  onFilterChange: (filters: Partial<ApplicantFilter>) => void;
  names: string[];
  contactNames: string[];
  emails: string[];
}

export default function ApplicantFilterPanel({
  isOpen,
  onClose,
  filters,
  onFilterChange,
  names,
  contactNames,
  emails
}: ApplicantFilterPanelProps) {
  if (!isOpen) return null;

  return (
    <div className="absolute right-0 top-full mt-2 w-96 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
      <div className="p-4">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">Filters</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Name
            </label>
            <select
              value={filters.name || ''}
              onChange={(e) => onFilterChange({ name: e.target.value || null })}
              className="w-full rounded-md border border-gray-300 py-2 px-3 focus:outline-none focus:ring-1 focus:ring-primary"
            >
              <option value="">All Names</option>
              {names.map((name) => (
                <option key={name} value={name}>
                  {name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Contact Name
            </label>
            <select
              value={filters.contactName || ''}
              onChange={(e) => onFilterChange({ contactName: e.target.value || null })}
              className="w-full rounded-md border border-gray-300 py-2 px-3 focus:outline-none focus:ring-1 focus:ring-primary"
            >
              <option value="">All Contact Names</option>
              {contactNames.map((contactName) => (
                <option key={contactName} value={contactName}>
                  {contactName}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <select
              value={filters.email || ''}
              onChange={(e) => onFilterChange({ email: e.target.value || null })}
              className="w-full rounded-md border border-gray-300 py-2 px-3 focus:outline-none focus:ring-1 focus:ring-primary"
            >
              <option value="">All Emails</option>
              {emails.map((email) => (
                <option key={email} value={email}>
                  {email}
                </option>
              ))}
            </select>
          </div>

          <div className="pt-4 border-t">
            <button
              onClick={() => onFilterChange({
                name: null,
                contactName: null,
                email: null
              })}
              className="w-full px-4 py-2 text-sm text-primary hover:bg-primary/5 rounded-md"
            >
              Clear All Filters
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
